import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import Translation from '../../../../../../../common/components/translation/Translation';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

const ChosenTermContainer: FC = () => {
  const { selectedCar } = useCustomizeCarContext();
  const duration = selectedCar?.finance?.simulation?.loanTermPeriod?.value ?? 0;

  return (
    <Rate
      labelId={RateTypes.PAYMENT_TERM}
      value={
        <Translation
          values={{ value: +duration ?? 0, duration }}
          id="trans__configurator__customise_page_finance_details__sticky_footer_term_value_label"
        />
      }
    />
  );
};

export default ChosenTermContainer;
